import axios from 'utils/axios';
import { put } from 'redux-saga/effects';
import * as AppTour from 'actions/AppTour';
import { getTourBitmaskPositionFromObjectKey, getValueFromCurrentTourBitmaskByKey, setFalseValueOnTourBitmaskByKey, setTrueValueOnTourBitmaskByKey } from 'utils/helpers.js'

export function* onSaveStatusRequest({params, cb}) {

  let setBitmask = null

  if(params.value === true) {
    setBitmask = setTrueValueOnTourBitmaskByKey(params.key)
  }
  else {
    setBitmask = setFalseValueOnTourBitmaskByKey(params.key)
  }

  try {
    const res = yield axios.post(`/api/student/setTakenTours`, `"${setBitmask}"`);
    yield put(AppTour.onSaveStatusSuccess(params || {}));
    cb && cb(null, params);
  } catch (e) {
    yield put(AppTour.onSaveStatusFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}